/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelogcharts_Typesofchangesdesc4Inputs */

const id_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah perubahan berdasarkan jenis`)
};

const ms_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuantiti perubahan mengikut jenis`)
};

const da_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antal ændringer efter type`)
};

const de_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Änderungen nach Typ`)
};

const en_us2_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantity of changes by type`)
};

const es_es2_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad de cambios por tipo`)
};

const es_mx2_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad de cambios por tipo`)
};

const fil_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilang ng mga pagbabago ayon sa uri`)
};

const fr_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantité de modifications par type`)
};

const it_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantità di modifiche per tipo`)
};

const hu_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változások mennyisége típus szerint`)
};

const nl_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveelheid wijzigingen per type`)
};

const no_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antall endringer etter type`)
};

const pl_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liczba zmian według typu`)
};

const pt_br2_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantity of changes by type`)
};

const pt_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantidade de alterações por tipo`)
};

const ro_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantitatea de modificări după tip`)
};

const fi_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutosten määrä tyypeittäin`)
};

const sv_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antal ändringar per typ`)
};

const vi_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng thay đổi theo loại`)
};

const tr_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türe göre değişiklik sayısı`)
};

const cs_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počet změn podle typu`)
};

const bg_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество промени по тип`)
};

const ru_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество изменений по типу`)
};

const uk_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кількість змін за типом`)
};

const ar_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عدد التغييرات حسب النوع`)
};

const hi_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकार के अनुसार परिवर्तन`)
};

const th_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จำนวนการเปลี่ยนแปลงตามประเภท`)
};

const ja_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイプ別の変更数`)
};

const zh_cn2_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantity of changes by type`)
};

const zh_hant1_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantity of changes by type`)
};

const ko_components_changelogcharts_typesofchangesdesc4 = /** @type {(inputs: Components_Changelogcharts_Typesofchangesdesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantity of changes by type`)
};

/**
* | output |
* | --- |
* | "Quantity of changes by type" |
*
* @param {Components_Changelogcharts_Typesofchangesdesc4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelogcharts_typesofchangesdesc4 = /** @type {((inputs?: Components_Changelogcharts_Typesofchangesdesc4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelogcharts_Typesofchangesdesc4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "ms") return ms_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "da") return da_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "de") return de_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "en-US") return en_us2_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "es-ES") return es_es2_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "es-MX") return es_mx2_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "fil") return fil_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "fr") return fr_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "it") return it_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "hu") return hu_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "nl") return nl_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "no") return no_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "pl") return pl_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "pt") return pt_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "ro") return ro_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "fi") return fi_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "sv") return sv_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "vi") return vi_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "tr") return tr_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "cs") return cs_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "bg") return bg_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "ru") return ru_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "uk") return uk_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "ar") return ar_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "hi") return hi_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "th") return th_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "ja") return ja_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelogcharts_typesofchangesdesc4(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelogcharts_typesofchangesdesc4(inputs)
	return ko_components_changelogcharts_typesofchangesdesc4(inputs)
});
export { components_changelogcharts_typesofchangesdesc4 as "components.changelogCharts.typesOfChangesDesc" }